import React from 'react';

import { useTranslation } from 'react-i18next';

import type { AssetRopaWarningFlags } from 'config/api/ropaReviews/ropaReviews.types';
import processing_activities_messages from 'messages/processing_activities_messages';

import useStyles from '../../ProcessingActivitiesAssetReviewsPage/ProcessingActivitiesAssetReviewsPage.styles';

type Props = {
  inline?: boolean;
  warnings: AssetRopaWarningFlags;
};

const AssetRopaWarningChips: React.FC<Props> = ({ inline = false, warnings }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const messages = processing_activities_messages.asset_ropa.warnings;

  const chips = [
    warnings.dpiaIndicated ? t(messages.dpia_indicated) : null,
    warnings.dpiaRequiredUnapproved ? t(messages.dpia_required_unapproved) : null,
    warnings.thirdCountryProcessing ? t(messages.third_country_processing) : null,
    warnings.sensitivePersonalData ? t(messages.sensitive_personal_data) : null,
    warnings.confirmedNoProcessingActivities ? t(messages.confirmed_no_processing_activities) : null,
  ].filter(Boolean) as string[];

  if (chips.length === 0) return null;

  const chipNodes = chips.map(chip => (
    <span key={chip} className={styles.warningChip}>
      {chip}
    </span>
  ));

  if (inline) {
    return <>{chipNodes}</>;
  }

  return <div className={styles.assetSummaryStatus}>{chipNodes}</div>;
};

export default AssetRopaWarningChips;
